module.exports = __webpack_public_path__ + "media/images/static/interview/interview_3-a48d97c831c76d06d7646a759018d431.png";